/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_Subscription_Change_Plan_TitleInputs */

const en_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Plan`)
};

const ar_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الخطة`)
};

const de_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan ändern`)
};

const es_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar plan`)
};

const fr_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de plan`)
};

const it_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia piano`)
};

const ja_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランの変更`)
};

const ko_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜 변경`)
};

const pt_br_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar plano`)
};

const ru_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить план`)
};

const th_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนแผน`)
};

const tr_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planı Değiştir`)
};

const zh_cn_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变更方案`)
};

const zh_tw_manage_subscription_change_plan_title = /** @type {(inputs: Manage_Subscription_Change_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更方案`)
};

/**
* | output |
* | --- |
* | "Change Plan" |
*
* @param {Manage_Subscription_Change_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const manage_subscription_change_plan_title = /** @type {((inputs?: Manage_Subscription_Change_Plan_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_Subscription_Change_Plan_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_subscription_change_plan_title(inputs)
	if (locale === "ar") return ar_manage_subscription_change_plan_title(inputs)
	if (locale === "de") return de_manage_subscription_change_plan_title(inputs)
	if (locale === "es") return es_manage_subscription_change_plan_title(inputs)
	if (locale === "fr") return fr_manage_subscription_change_plan_title(inputs)
	if (locale === "it") return it_manage_subscription_change_plan_title(inputs)
	if (locale === "ja") return ja_manage_subscription_change_plan_title(inputs)
	if (locale === "ko") return ko_manage_subscription_change_plan_title(inputs)
	if (locale === "pt_br") return pt_br_manage_subscription_change_plan_title(inputs)
	if (locale === "ru") return ru_manage_subscription_change_plan_title(inputs)
	if (locale === "th") return th_manage_subscription_change_plan_title(inputs)
	if (locale === "tr") return tr_manage_subscription_change_plan_title(inputs)
	if (locale === "zh_cn") return zh_cn_manage_subscription_change_plan_title(inputs)
	return zh_tw_manage_subscription_change_plan_title(inputs)
});